import { render, staticRenderFns } from "./projectNeedDetail.vue?vue&type=template&id=04e07da3&scoped=true"
import script from "./projectNeedDetail.vue?vue&type=script&lang=js"
export * from "./projectNeedDetail.vue?vue&type=script&lang=js"
import style0 from "./projectNeedDetail.vue?vue&type=style&index=0&id=04e07da3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e07da3",
  null
  
)

export default component.exports